import { Badge } from "@/components/ui/badge";

type AppRole = "admin" | "assessor" | "approver" | "expert" | "vendor";

const ROLE_LABELS: Record<AppRole, string> = {
  admin: "Admin",
  assessor: "Assessor",
  approver: "Approver",
  expert: "Expert",
  vendor: "Vendor",
};

const ROLE_STYLES: Record<AppRole, string> = {
  admin: "bg-primary/10 text-primary border-primary/20",
  approver: "bg-blue-500/10 text-blue-700 dark:text-blue-400 border-blue-500/20",
  assessor: "bg-muted text-muted-foreground border-border",
  expert: "bg-violet-500/10 text-violet-700 dark:text-violet-400 border-violet-500/20",
  vendor: "bg-amber-500/10 text-amber-700 dark:text-amber-400 border-amber-500/20",
};

const HIDDEN_ROLES: AppRole[] = ["expert", "vendor"];

interface RoleBadgesProps {
  roles: AppRole[];
  size?: "sm" | "default";
  showAll?: boolean;
}

export function RoleBadges({ roles, size = "default", showAll = false }: RoleBadgesProps) {
  const visibleRoles = showAll ? roles : roles.filter((r) => !HIDDEN_ROLES.includes(r));
  if (visibleRoles.length === 0) return null;

  return (
    <span className="inline-flex flex-wrap gap-1">
      {visibleRoles.map((role) => (
        <Badge
          key={role}
          variant="outline"
          className={`${ROLE_STYLES[role]} font-medium ${
            size === "sm" ? "text-[10px] px-1.5 py-0" : "text-xs"
          }`}
        >
          {ROLE_LABELS[role]}
        </Badge>
      ))}
    </span>
  );
}
